import React, { useState, useEffect, useRef } from 'react';
import FsLightbox from 'fslightbox-react';
import './Carousel.css';
import ibrahim1 from './ibrahim1.jpg';
import ibrahim2 from './ibrahim2.jpg';
import ibrahim6 from './ibrahim6.jpg';
import ibrahim5 from './ibrahim5.jpg';

const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [lightboxController, setLightboxController] = useState({ toggler: false, slide: 1 });
  const [slidesPerView, setSlidesPerView] = useState(3);
  const carouselRef = useRef();
  const controlsRef = useRef();

  const slides = [
    { image: ibrahim1 },
    { image: ibrahim2 },
    { image: ibrahim5 },
    { image: ibrahim6 },
  ];

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 600) setSlidesPerView(1);
      else if (width < 900) setSlidesPerView(2);
      else setSlidesPerView(3);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % (slides.length - slidesPerView + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length, slidesPerView]);

  useEffect(() => {
    let startX = 0;
    let endX = 0;
    
    const handleTouchStart = (e) => {
      // Don't handle touch events on control buttons
      if (controlsRef.current?.contains(e.target)) {
        return;
      }
      startX = e.touches[0].clientX;
    };
    
    const handleTouchMove = (e) => {
      // Don't handle touch events on control buttons
      if (controlsRef.current?.contains(e.target)) {
        return;
      }
      endX = e.touches[0].clientX;
    };
    
    const handleTouchEnd = (e) => {
      // Don't handle touch events on control buttons
      if (controlsRef.current?.contains(e.target)) {
        return;
      }
      
      const swipeDistance = startX - endX;
      if (Math.abs(swipeDistance) > 50) {
        if (swipeDistance > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    };
    
    const container = carouselRef.current;
    container?.addEventListener('touchstart', handleTouchStart);
    container?.addEventListener('touchmove', handleTouchMove);
    container?.addEventListener('touchend', handleTouchEnd);
    return () => {
      container?.removeEventListener('touchstart', handleTouchStart);
      container?.removeEventListener('touchmove', handleTouchMove);
      container?.removeEventListener('touchend', handleTouchEnd);
    };
  }, [activeIndex]);

  const maxIndex = slides.length - slidesPerView;

  const prevSlide = () => setActiveIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  const nextSlide = () => setActiveIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));

  const handleButtonClick = (callback) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    callback();
  };

  const openLightboxOnSlide = (index) => {
    setLightboxController({ toggler: !lightboxController.toggler, slide: index + 1 });
  };

  return (
    <div className="carousel-container" ref={carouselRef}>
      <div
        className="carousel-track"
        style={{ transform: `translateX(-${activeIndex * (100 / slidesPerView)}%)` }}
      >
        {slides.map((slide, i) => (
          <div key={i} className="carousel-slide">
            <div
              className="slide-image-container"
              onClick={() => openLightboxOnSlide(i)}
              style={{ cursor: 'pointer' }}
            >
              <img src={slide.image} alt={`Slide ${i + 1}`} className="slide-img" />
              <div className="slide-overlay" />
            </div>
          </div>
        ))}
      </div>

      <div className="carousel-controls" ref={controlsRef}>
        <button 
          className="carousel-button" 
          onClick={handleButtonClick(prevSlide)}
          onTouchEnd={handleButtonClick(prevSlide)}
        >
          <svg viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <button 
          className="carousel-button" 
          onClick={handleButtonClick(nextSlide)}
          onTouchEnd={handleButtonClick(nextSlide)}
        >
          <svg viewBox="0 0 24 24">
            <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
          </svg>
        </button>
      </div>

      <FsLightbox
        toggler={lightboxController.toggler}
        sources={slides.map((slide) => slide.image)}
        slide={lightboxController.slide}
      />
    </div>
  );
};

export default Carousel;